/**
 * Returns values from `array`. if element with same key exists in `second`, returns element from second instead
 */
export const pickIfExists = (array, second, key) => {
    return array.map(it => second.find(sm => sm[key] === it[key]) || it);
};
//# sourceMappingURL=arrays.utils.js.map